import React from 'react';

// Utils
import { useClass } from '@breezerr';

// Components
import { Sections } from '@brz-components/sections';
import { PageContentRenderer } from '@brz-utils/page.content.renderer';
import { Backdrop, CircularProgress, Fade } from '@mui/material';


// Types
import type { PageDataModel } from './types';
import type { PagePropsModel } from '@brz-utils/contexts/page.context';


type Props = {
    data: PageDataModel<
        // List of all possible section types
        { __typename: '' }
    >;
    pageProps: PagePropsModel
};

const GenericPageRender = (props: Props) => {
    const { data, pageProps } = props;

    return (
        <PageContentRenderer settings={data.node.settings} pageProps={pageProps}>
           {data?.node.content ? (
                <Sections sections={data.node.content} />
            ) : (
                <div className={useClass('w-100% h-80vh d-flex align-items-center justify-content-center')}>No Content</div>
            )}
        </PageContentRenderer>
    );
};

export default GenericPageRender;